import { useState, useEffect } from "react";
import axios from 'axios';
import { Header } from "./components/header/Header.component.jsx";
import { Static } from "./components/static/Static.component";

function App() {
  const [apiUrl, setApiUrl] = useState(null);
  // Get the header api from the web.config
  useEffect(() => {
    axios.post("VisitorApplication.aspx/GetHeaderApiUrl", {key: "key"})
			.then(res => {
				setApiUrl(res.data.d)
			});
  },[]);

  if (apiUrl) {
    return (
      <Header apiUrl={apiUrl} />
    );
  } else {
    return <Static />
  }
  
}

export default App;
